<res-base-modal
    [modalTitle]="'Download OCR Usage Report'" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'Download Report'" (primaryButtonActionEmt)="downloadOCRUsageReport()" (closeButtonActionEmt)="closeModal()"
    [isPrimaryBtnEnabled]="!invalidDate"
    [secondaryButtonLabel]="'Cancel'"
    [modalHelpIndex]="modalHelpIndex">

    <div class="modal-row">
        <div class="modal-row-column-auto optionsList">
            <span class="range-indicator">Date Range:</span>
            <res-custom-date-time-picker #dateStart class="date-time-picker" name="dateStart" ngDefaultControl
                        [inputPlaceholder]="defaultDatePlaceholders[0]" (click)="onDateClick($event,'start')"
                        (focusout)="onFocusLost($event,'start');" [(ngModel)]="ocrDateReportObject.startDate"
                        [isDateRange]="true" [hasErrorMessage]="dateError" [isStart]="true" [isEnd]="false"
                        (ngModelChange)="dateChanged('start', $event)"
                        [automationId]="modalAutomationId + '-start-date-time-picker'">
             </res-custom-date-time-picker>
            <div class="picker-separator">~~</div>
            <res-custom-date-time-picker #dateEnd class="date-time-picker" name="dateEnd" ngDefaultControl
                        [inputPlaceholder]="defaultDatePlaceholders[1]" (click)="onDateClick($event,'end')"
                        (focusout)="onFocusLost($event,'end')" [(ngModel)]="ocrDateReportObject.endDate"
                        [isDateRange]="true" [hasErrorMessage]="dateError" [isStart]="false" [isEnd]="true"
                        (ngModelChange)="dateChanged('end')"
                        [automationId]="modalAutomationId + '-end-date-time-picker'">
            </res-custom-date-time-picker>
        </div>
    </div>
    <a download #downloadLink hidden target="_blank"></a>
</res-base-modal>